import Axios from '@/utils/union-axios'
import request from '@/network/request'

const urlPrefix = '/trips_report'

/**
 * 行程列表
 */
export function getTripsList(params) {
  return Axios.get(`${urlPrefix}/web/adTripsReport/trips/list`, params)
}

/**
 * 行程数据概括
 */
export function getTripsSummary(params) {
  return Axios.get(`${urlPrefix}/web/adTripsReport/trips/summary`, params)
}

/**
 * 查询智驾亮点数据 [新增]
 */
export function getTripsHighlights(params) {
  return Axios.get(`${urlPrefix}/web/adTripsReport/highlights`, params)
}

/**
 * 行程数据详情
 */
export function getTripsDetail(params) {
  return Axios.get(`${urlPrefix}/web/adTripsReport/trips/detail`, params)
}

/**
 * 单车用户信息
 */
export function getUserVehicleInfo(params) {
  return Axios.get(`${urlPrefix}/web/user/vehicle/info`, params)
}

/**
 * 单车行驶里程信息
 */
export function getMileageVehicleInfo(params) {
  return Axios.get(`${urlPrefix}/web/adTripsReport/driveOverview`, params)
}

/**
 * 删除单条行程数据
 */
export function postRemoveTripData(params) {
  return Axios.post(`${urlPrefix}/web/adTripsReport/trips/remove`, params)
}

/**
 * 行程记录开启状态
 */
export function getEnableRecordStatus(params) {
  return Axios.get(`${urlPrefix}/web/user/adTripsReport/settings/moduleEnabled`, params)
}

/**
 * 开关行程记录
 */
export function postSwitchEnableRecord(params, vin) {
  return Axios.post(`${urlPrefix}/web/user/adTripsReport/settings/edit?vin=${vin}`, params)
}

/**
 * 获取公告栏信息
 * @param params 
 * @returns 
 */
export function getAnnouncement(params) {
  return request('/xp-cs-app-boot/resources/positions', params)
}

/**
 * 行程记录和位置信息开启状态
 */
export function getSettingsQuery(params) {
  return Axios.get(`${urlPrefix}/web/user/adTripsReport/settings/query`, params)
}